import { IFlow } from "../constants/flowType";
import CheckOut from "./CheckOut";
import PaymentError from "./PaymentError";

export const bookFlowSteps = {
    default: 1,
    errorPayment: 2,
}
export const cardFlowSteps = {
    default: 1,
    errorPayment: 2,
}

export const buyBookFlow: IFlow = [
    {
        component: CheckOut,
        props: { isBook: true,  payStep: bookFlowSteps.default }
    },
    {
        component: PaymentError,
        props: {
            payStep: bookFlowSteps.default,
            text: 'payment.errors.payment',
            secondTextLine: 'payment.errors.try_again_balance',
        },
    },
]
export const copyBookFlow: IFlow =  [
    {
        component: CheckOut,
        props: { isBook: false,  payStep: bookFlowSteps.default }
    },
    {
        component: PaymentError,
        props: {
            payStep: bookFlowSteps.default,
            text: 'payment.errors.payment',
            secondTextLine: 'payment.errors.try_again_balance',
        },
    },
]

export const copyCardFlow: IFlow = [
    {
        component: CheckOut,
        props: { isCard: true, payStep: cardFlowSteps.default }
    },
    {
        component: PaymentError,
        props: {
            payStep: cardFlowSteps.default,
            text: 'payment.errors.payment',
            secondTextLine: 'payment.errors.try_again_balance',
        },
    },
]import { IFlow } from "../constants/flowType";
import CheckOut from "./CheckOut";
import PaymentError from "./PaymentError";

export const bookFlowSteps = {
    default: 1,
    errorPayment: 2,
}
export const cardFlowSteps = {
    default: 1,
    errorPayment: 2,
}

export const buyBookFlow: IFlow = [
    {
        component: CheckOut,
        props: { isBook: true,  payStep: bookFlowSteps.default }
    },
    {
        component: PaymentError,
        props: {
            payStep: bookFlowSteps.default,
            text: 'payment.errors.payment',
            secondTextLine: 'payment.errors.try_again_balance',
        },
    },
]
export const copyBookFlow: IFlow =  [
    {
        component: CheckOut,
        props: { isBook: false,  payStep: bookFlowSteps.default }
    },
    {
        component: PaymentError,
        props: {
            payStep: bookFlowSteps.default,
            text: 'payment.errors.payment',
            secondTextLine: 'payment.errors.try_again_balance',
        },
    },
]

export const copyCardFlow: IFlow = [
    {
        component: CheckOut,
        props: { isCard: true, payStep: cardFlowSteps.default }
    },
    {
        component: PaymentError,
        props: {
            payStep: cardFlowSteps.default,
            text: 'payment.errors.payment',
            secondTextLine: 'payment.errors.try_again_balance',
        },
    },
]